export default __webpack_public_path__ + "static/media/rfdigital_1.8f0ff748.png";